import React from "react";
import styled from "styled-components";
import cover7 from "../../image/Works/hyatt1cover.png";
import cover8 from "../../image/Works/uo1cover.jpg";
import cover9 from "../../image/Works/uo2cover.jpg";
import cover10 from "../../image/Works/flats1cover.jpg";
import { BsPlayCircle } from "react-icons/bs";
import { motion } from "framer-motion";

const Container = styled(motion.div)`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.body};
  margin-bottom: 5rem;
  overflow-x: hidden;
`;

const VideoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 0;
  padding: 5rem 0;
  position: relative;
`;

const ImageContainer = styled.div`
  width: 60%;
  height: 24rem;
  object-fit: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  opacity: 0.3;

  @media only screen and (max-width: 1024px) {
    width: 100%;
    height: auto;
  }

  &:hover {
    scale: 1.03;
    transition: 0.5s;
    transition-delay: 0s;
    opacity: 0.9;
  }
`;

const Title = styled.h1`
  color: ${(props) => props.theme.text};
  position: absolute;
  left: 15%;
  top: 55%;
  font-size: 60px;
  z-index: 10;
  text-shadow: 3px 3px 3px ${(props) => props.theme.body};

  @media only screen and (max-width: 1024px) {
    width: 100%;
    position: absolute;
    left: 5%;
    top: 65%;
    font-size: 30px;
  }
`;

const PlayIcon = styled.h1`
  color: ${(props) => props.theme.text};
  position: absolute;
  z-index: 10;
  text-shadow: 3px 3px 3px ${(props) => props.theme.body};
  opacity: 0.75;
  &:hover {
    scale: 1.03;
    transition: 0.5s;
    transition-delay: 0s;
    opacity: 0.9;
    color: ${(props) => props.theme.body};
  }
`;

const Header = styled.h1`
  color: ${(props) => props.theme.text};
  font-size: 60px;
  font-weight: 500;
  margin-top: 5rem;
  width: 100%;
  text-align: center;

  @media only screen and (max-width: 1024px) {
    font-size: 48px;
    height: auto;
  }
`;

const Subtitle = styled.h1`
  width: 60%;
  color: ${(props) => props.theme.text};
  font-size: 24px;
  font-weight: 400;
  z-index: 10;
  text-shadow: 3px 3px 3px ${(props) => props.theme.body};
  text-align: right;
  margin: 0.75rem 0;
  padding-right: 1.5rem;
  opacity: 0.75;

  @media only screen and (max-width: 1024px) {
    width: 100%;
    font-size: 18px;
  }
`;

const Japan = ({
  t,
  toggleVideo_hyatt,
  toggleVideo_uo,
  toggleVideo_uo2,
  toggleImg_flats,
}) => {
  const initial = { opacity: 0, scale: 1, y: 100 };
  const whileInView = { opacity: 1, scale: 1, y: 0 };
  const viewport = { once: true };
  const transition = {
    duration: 0.8,
    ease: "easeInOut",
    mass: 0.3,
    delay: 0.2,
  };

  return (
    <Container
      initial={initial}
      whileInView={whileInView}
      viewport={viewport}
      transition={transition}
    >
      <Header>{t("workFilms")}</Header>
      <VideoContainer onClick={() => toggleVideo_hyatt()}>
        <Title>Park Hyatt Kyoto</Title>
        <PlayIcon>
          <BsPlayCircle size={100} />
        </PlayIcon>
        <ImageContainer>
          <img src={cover7} width="100%" alt=""/>
        </ImageContainer>
        <Subtitle>{t("categoryArchitecture")}</Subtitle>
      </VideoContainer>

      <VideoContainer onClick={() => toggleVideo_uo()}>
        <Title>uo (由布岳)</Title>
        <PlayIcon>
          <BsPlayCircle size={100} />
        </PlayIcon>
        <ImageContainer>
          <img src={cover8} width="100%" alt=""/>
        </ImageContainer>
        <Subtitle>{t("categoryFashion")}</Subtitle>
      </VideoContainer>

      <VideoContainer onClick={() => toggleVideo_uo2()}>
        <Title>uo (由布岳)</Title>
        <PlayIcon>
          <BsPlayCircle size={100} />
        </PlayIcon>
        <ImageContainer>
          <img src={cover9} width="100%" alt=""/>
        </ImageContainer>
        <Subtitle>{t("categoryFashion")}</Subtitle>
      </VideoContainer>

      <Header>{t("workPhoto")}</Header>
      <VideoContainer onClick={() => toggleImg_flats()}>
        <Title>Flats (平面)</Title>
        <PlayIcon>
          <BsPlayCircle size={100} />
        </PlayIcon>
        <ImageContainer>
          <img src={cover10} width="100%" alt=""/>
        </ImageContainer>
        <Subtitle>{t("categoryModel")}</Subtitle>
      </VideoContainer>
    </Container>
  );
};

export default Japan;
